// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Admin: patient detail
 */

.AdminPatient_page__jkMoV {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.AdminPatient_back__vzVLM {
  font-size: 0.875rem;
  color: var(--text-secondary);
  text-decoration: none;
}

.AdminPatient_header__UVOVx {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-4);
}

.AdminPatient_title__Ooi6u {
  font-size: clamp(1.2rem, 1.05rem + 0.6vw, 1.6rem);
  font-weight: 700;
  margin: 0;
  overflow-wrap: anywhere;
}

.AdminPatient_tags__1ncjq {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
  margin-top: var(--space-2);
}

.AdminPatient_facts__T8UI4 {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: var(--space-1) var(--space-3);
  margin: 0;
  font-size: 0.9375rem;
}

.AdminPatient_facts__T8UI4 dt {
  color: var(--text-secondary);
}

.AdminPatient_facts__T8UI4 dd {
  margin: 0;
}

.AdminPatient_muted__w7tfI {
  color: var(--text-secondary);
  margin: 0;
}

.AdminPatient_warn__Bep1K {
  color: var(--warning);
  font-weight: 600;
}

.AdminPatient_strip__ArY-9 {
  display: grid;
  grid-template-columns: repeat(14, minmax(44px, 1fr));
  gap: var(--space-1);
  overflow-x: auto;
}

.AdminPatient_day__ZHSyV,
.AdminPatient_dayBusy__d3kss,
.AdminPatient_dayActive__0RT4l {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: var(--space-2) var(--space-1);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg);
  font: inherit;
  font-size: 0.8125rem;
  color: var(--text-secondary);
  cursor: pointer;
}

.AdminPatient_dayBusy__d3kss {
  color: var(--text-primary);
  background: var(--bg-secondary);
}

.AdminPatient_dayActive__0RT4l {
  color: var(--primary);
  border-color: var(--primary);
  background: var(--surface-brand-wash);
}

.AdminPatient_dayName__m5Wbx {
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.AdminPatient_dayCount__JUfqz {
  font-weight: 700;
}

.AdminPatient_controls__3Hxur {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-4);
}

.AdminPatient_control__eHTDN {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 180px;
}

.AdminPatient_summary__CB9DH {
  font-weight: 600;
  margin: 0 0 var(--space-3);
}

.AdminPatient_sessions__0HRuh {
  list-style: none;
  margin: 0;
  padding: 0;
}

.AdminPatient_session__YGpUN {
  border-bottom: 1px solid var(--border-light);
}

.AdminPatient_sessionHead__1qeTz {
  display: grid;
  grid-template-columns: 80px minmax(140px, 2fr) 60px 90px minmax(100px, 1fr) minmax(120px, 1.2fr);
  gap: var(--space-2);
  align-items: center;
  width: 100%;
  padding: var(--space-3) 0;
  background: none;
  border: 0;
  font: inherit;
  font-size: 0.9375rem;
  text-align: left;
  color: var(--text-primary);
  cursor: pointer;
}

.AdminPatient_sessionHead__1qeTz:hover {
  background: var(--bg-secondary);
}

@media (max-width: 720px) {
  .AdminPatient_sessionHead__1qeTz {
    grid-template-columns: 1fr 1fr;
  }
}

.AdminPatient_time__cGfG3 {
  font-variant-numeric: tabular-nums;
  color: var(--text-secondary);
}

.AdminPatient_exercise__AnKxv {
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Admin/AdminPatient.module.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,kCAAkC;EAClC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;EACtC,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,gGAAgG;EAChG,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/*\n * Admin: patient detail\n */\n\n.page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n}\n\n.back {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  text-decoration: none;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n}\n\n.title {\n  font-size: clamp(1.2rem, 1.05rem + 0.6vw, 1.6rem);\n  font-weight: 700;\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n.tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-1);\n  margin-top: var(--space-2);\n}\n\n.facts {\n  display: grid;\n  grid-template-columns: max-content minmax(0, 1fr);\n  gap: var(--space-1) var(--space-3);\n  margin: 0;\n  font-size: 0.9375rem;\n}\n\n.facts dt {\n  color: var(--text-secondary);\n}\n\n.facts dd {\n  margin: 0;\n}\n\n.muted {\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.warn {\n  color: var(--warning);\n  font-weight: 600;\n}\n\n.strip {\n  display: grid;\n  grid-template-columns: repeat(14, minmax(44px, 1fr));\n  gap: var(--space-1);\n  overflow-x: auto;\n}\n\n.day,\n.dayBusy,\n.dayActive {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding: var(--space-2) var(--space-1);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg);\n  font: inherit;\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n\n.dayBusy {\n  color: var(--text-primary);\n  background: var(--bg-secondary);\n}\n\n.dayActive {\n  color: var(--primary);\n  border-color: var(--primary);\n  background: var(--surface-brand-wash);\n}\n\n.dayName {\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.dayCount {\n  font-weight: 700;\n}\n\n.controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n}\n\n.control {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  min-width: 180px;\n}\n\n.summary {\n  font-weight: 600;\n  margin: 0 0 var(--space-3);\n}\n\n.sessions {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.session {\n  border-bottom: 1px solid var(--border-light);\n}\n\n.sessionHead {\n  display: grid;\n  grid-template-columns: 80px minmax(140px, 2fr) 60px 90px minmax(100px, 1fr) minmax(120px, 1.2fr);\n  gap: var(--space-2);\n  align-items: center;\n  width: 100%;\n  padding: var(--space-3) 0;\n  background: none;\n  border: 0;\n  font: inherit;\n  font-size: 0.9375rem;\n  text-align: left;\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.sessionHead:hover {\n  background: var(--bg-secondary);\n}\n\n@media (max-width: 720px) {\n  .sessionHead {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.time {\n  font-variant-numeric: tabular-nums;\n  color: var(--text-secondary);\n}\n\n.exercise {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AdminPatient_page__jkMoV`,
	"back": `AdminPatient_back__vzVLM`,
	"header": `AdminPatient_header__UVOVx`,
	"title": `AdminPatient_title__Ooi6u`,
	"tags": `AdminPatient_tags__1ncjq`,
	"facts": `AdminPatient_facts__T8UI4`,
	"muted": `AdminPatient_muted__w7tfI`,
	"warn": `AdminPatient_warn__Bep1K`,
	"strip": `AdminPatient_strip__ArY-9`,
	"day": `AdminPatient_day__ZHSyV`,
	"dayBusy": `AdminPatient_dayBusy__d3kss`,
	"dayActive": `AdminPatient_dayActive__0RT4l`,
	"dayName": `AdminPatient_dayName__m5Wbx`,
	"dayCount": `AdminPatient_dayCount__JUfqz`,
	"controls": `AdminPatient_controls__3Hxur`,
	"control": `AdminPatient_control__eHTDN`,
	"summary": `AdminPatient_summary__CB9DH`,
	"sessions": `AdminPatient_sessions__0HRuh`,
	"session": `AdminPatient_session__YGpUN`,
	"sessionHead": `AdminPatient_sessionHead__1qeTz`,
	"time": `AdminPatient_time__cGfG3`,
	"exercise": `AdminPatient_exercise__AnKxv`
};
export default ___CSS_LOADER_EXPORT___;
